// extracted by mini-css-extract-plugin
export default {"content":"styles_content__RI+s0","field":"styles_field__FsVnx","reviewButton":"styles_reviewButton__hi96S","propertyProContainer":"styles_propertyProContainer__oJHRP"};